import { defineMessages } from 'react-intl'

export default defineMessages({
  passengerNoPassenger: {
    id: 'app.passenger.noPassenger',
    defaultMessage: 'No Passenger',
  },
  passengerThereWasPassenger: {
    id: 'app.passenger.passenger',
    defaultMessage: 'There Was a Passenger',
  },
  passengerHeadline: {
    id: 'app.passenger.headline',
    defaultMessage: 'Passenger Info',
  },

  // Validation messages
  validationAddressRequired: {
    id: 'app.passenger.validation.addressRequired',
    defaultMessage: 'Address is required!',
  },
  validationPhoneRequired: {
    id: 'app.passenger.validation.phoneRequired',
    defaultMessage: 'Phone number is required!',
  },
  validationFirstNameRequired: {
    id: 'app.passenger.validation.firstNameRequired',
    defaultMessage: 'First name is required!',
  },
  validationLastNameRequired: {
    id: 'app.passenger.validation.lastNameRequired',
    defaultMessage: 'Last name is required!',
  },

  // Placeholder messages
  placeholderFirstName: {
    id: 'app.passenger.placeholder.firstName',
    defaultMessage: 'First name',
  },
  placeholderLastName: {
    id: 'app.passenger.placeholder.lastName',
    defaultMessage: 'Last name',
  },
  placeholderPhoneNumber: {
    id: 'app.passenger.placeholder.phoneNumber',
    defaultMessage: 'Phone #',
  },
  placeholderAdress: {
    id: 'app.passenger.placeholder.address',
    defaultMessage: 'Address',
  },
  claimsFillOutTheForm: {
    id: 'app.claims.claimType.form',
    defaultMessage: 'Fill out the form',
  },
})
